import languageMixin from '@/mixins/language.mixin'
import { isItemReturned } from '@/helpers/shipment-items.utils'
import clientNameTrim from '@/helpers/clientNameTrimer'
import {
    formatPriceWithCurrency,
    getCurrencySymbol,
} from '@/helpers/format-price-with-currency'

export default {
    mixins: [languageMixin],
    methods: {
        formatPrice(price, currency = 'ILS') {
            return formatPriceWithCurrency(price, currency)
        },
        getCurrencySymbol(currency = 'ILS') {
            return getCurrencySymbol(currency)
        },
        openLink(link) {
            if (!link) return
            window.open(link, '_blank', 'noopener,noreferrer')
        },
        isItemDisabled(item) {
            return !!item.closed_at || isItemReturned(item)
        },
        formatClientWithStylist(item) {
            const rawClient = item?.wig?.client || ''
            const stylist = (item?.wig?.usmanager || '').trim()
            const clientName = rawClient
                ? (clientNameTrim(rawClient).clientName || '').trim()
                : ''
            if (clientName && stylist) return `${clientName} — ${stylist}`
            return clientName || stylist || '-'
        },
        getItemHeaders() {
            return [
                {
                    text: this.$t('pages.shipments.wig'),
                    value: 'wig',
                    sortable: false,
                },
                {
                    text: this.$t('pages.shipments.client'),
                    value: 'client',
                    sortable: false,
                },
                {
                    text: this.$t('pages.shipments.price'),
                    value: 'price',
                    sortable: false,
                },
                {
                    text: this.$t('pages.shipments.totalPaid'),
                    value: 'total_paid',
                    sortable: false,
                },
                {
                    text: this.$t('pages.shipments.remaining'),
                    value: 'remaining',
                    sortable: false,
                },
                {
                    text: this.$t('pages.shipments.documentNumber'),
                    value: 'document_number',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: this.$t('pages.shipments.document'),
                    value: 'document_link',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: this.$t('pages.shipments.closedAt'),
                    value: 'closed_at',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: this.$t('pages.shipments.receipts'),
                    value: 'receipts',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: this.$t('pages.shipments.actions'),
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                },
            ]
        },
    },
}
